module.exports = __webpack_public_path__ + "img/broadcast.2c0e9497.svg";